import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonButton, IonCheckbox, IonIcon, IonItem, IonRow, IonSpinner } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { informationCircleOutline } from 'ionicons/icons';

@Component({
  selector: 'app-student-slip-consent-form',
  templateUrl: './student-slip-consent-form.component.html',
  styleUrls: ['./student-slip-consent-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, IonItem, IonCheckbox, IonIcon, IonRow, IonButton, IonSpinner]
})
export class StudentSlipConsentFormComponent {
  @Input() question: string;
  @Input() canDecline: boolean;
  @Input() enableDeclineWarning: boolean;
  @Input() progress: { working: boolean; error: string; showReload: boolean };
  @Output() submitConsent = new EventEmitter<{ accepted: boolean }>();
  @Output() reloadSlip = new EventEmitter<void>();
  @ViewChild('acceptCheckbox', { static: true }) acceptCheckbox: IonCheckbox;
  public declineCheckbox: IonCheckbox;
  @ViewChild('declineCheckbox') set content(content: IonCheckbox) {
    if (content) {
      this.declineCheckbox = content;
    }
  }
  public acceptChecked = false;
  public declineChecked = false;

  constructor() {
    addIcons({ informationCircleOutline });
  }

  onSubmit(): void {
    this.submitConsent.emit({ accepted: this.acceptChecked });
  }

  get isFormValid(): boolean {
    return this.acceptChecked || this.declineChecked;
  }

  get declining(): boolean {
    return this.declineChecked;
  }

  onAcceptChecked(): void {
    this.acceptChecked = !this.acceptChecked;
    if (this.canDecline && this.acceptChecked && this.declineChecked) {
      this.declineChecked = false;
    }
  }

  onDeclineChecked(): void {
    this.declineChecked = !this.declineChecked;
    if (this.declineChecked && this.acceptChecked) {
      this.acceptChecked = false;
    }
  }
}
